import React from "react";
import { BaseFilterProps } from "../../lib";
import {
    OptionsMultiselectFilter,
    SchedulesReportFilterOption,
} from "./OptionsMultiselectFilter";

interface Props extends BaseFilterProps {
    options: SchedulesReportFilterOption[];
}

export const HoldingAccountFilter: React.FC<Props> = ({
    filters,
    onChange,
    options,
}) => (
    <OptionsMultiselectFilter
        options={options}
        selectedIds={filters.holdingAccountIds ?? []}
        onChange={(holdingAccountIds) => onChange({ holdingAccountIds })}
        name="holdingAccount"
    />
);
